import axios from "@/api/axios";

export default {
  formatStringDateToUs(dataString){
    let res = dataString.split('/');
    if(res.length == 3){
      return `${res[2]}-${res[1]}-${res[0]}`
    }
    else{
      return dataString;
    }
  },
  formatOnlyCharsString(value){
    let res = value;
    res = res.split('-').join("");
    res = res.split('/').join("");
    res = res.split('.').join("");
    res = res.split(',').join("");
    res = res.split('(').join("");
    res = res.split(')').join("");
    res = res.split(' ').join("");
    
    return res;
  },
  getClientUserPermissions(){
    return new Promise(function(resolve, reject){
      axios.get(`${process.env.VUE_APP_API_HOST}/api/client_permissions`)
      .then( response => {
        resolve(response.data);
      })
      .catch( error => {
        reject(error)
      })
    });
  },
  clientCanAccessItem(client, item){
    if(client && client.products){
      let find = false;
      client.products.forEach(element => {
        if(element.name == item)
          find = true;
      });
      return find;
    }
    else{
      return false;
    }
  },
  clientQuantityAccessItem(client, item){
    if(client && client.products){
      let quantity = 0;
      client.products.forEach(element => {
        if(element.name == item)
          quantity = element.pivot.quantity;
      });
      return quantity;
    }
    else{
      return 0;
    }
  },
  limitText(text, limit){
    if(text){
      return text.substring(0, limit) + (text.length > limit ? '...' : '');
    }
    else{
      return '';
    }
  }
}